let _profUserId = 'default'; try { require('@react-native-async-storage/async-storage').default.getItem('userToken').then(function(t){if(t)_profUserId=t.slice(0,16);}).catch(function(){}); } catch(e) {}
import React, { useState, useRef, useEffect } from 'react';
import {
  SafeAreaView,
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  Image,
  TextInput,
  Alert,
  Switch,
  Modal,
  Animated,
  StatusBar,
  Dimensions,
  ActivityIndicator,
  RefreshControl,
  Linking,
} from 'react-native';
import {
  Ionicons,
  MaterialCommunityIcons,
  MaterialIcons,
  FontAwesome5,
  AntDesign,
  Feather,
} from '@expo/vector-icons';
import { useFocusEffect } from '@react-navigation/native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { apiFetch } from '../../utils/apiClient';
import ProfileManagementService from '../../services/ProfileManagementService';
import PROFILE_KEYS from '../../constants/profileKeys';
import useProfile from '../../hooks/useProfile';

// === API CONFIG ===
const API_BASE = 'https://api.jobeng.ai';
const API_KEY = '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef';
const { width, height } = Dimensions.get('window');

// ** PORTFOLIO INTEGRATION **
const PortfolioService = {
  async getProfile() {
    try {
      const profileData = await AsyncStorage.getItem(`professional_${_profUserId}_userProfile`);
      if (profileData) {
        const profile = JSON.parse(profileData);
        console.log('✅ Portfolio profile loaded for webinar registration');
        return profile;
      }
      return null;
    } catch (error) {
      console.error('❌ Error loading portfolio profile:', error);
      return null;
    }
  },

  async saveWebinarRegistration(registrationData) {
    try {
      const key = `webinar_registration_${registrationData.webinarId}`;
      const dataToSave = {
        ...registrationData,
        registrationDate: new Date().toISOString(),
        status: 'registered'
      };
      
      await AsyncStorage.setItem(key, JSON.stringify(dataToSave));
      console.log('✅ Webinar registration saved to portfolio');
      
      return dataToSave;
    } catch (error) {
      console.error('❌ Error saving webinar registration:', error);
      throw error;
    }
  }
};

// ** WEBINAR SERVICE **
const WebinarService = {
  async getWebinarDetails(webinarId) {
    try {
      console.log('🔄 Loading webinar details...');
      
      // Try to load from storage first
      const storedData = await AsyncStorage.getItem(`webinar_${webinarId}`);
      if (storedData) {
        return JSON.parse(storedData);
      }
      
      // Return enhanced mock data
      return this.getEnhancedMockWebinar();
      
    } catch (error) {
      console.error('❌ Error loading webinar details:', error);
      return this.getEnhancedMockWebinar();
    }
  },

  getEnhancedMockWebinar() {
    return {
      id: 'web_001',
      title: 'Future of Sustainable Construction',
      subtitle: 'Innovations in Green Building Technology',
      presenter: 'Emma Davis, LEED AP',
      presenterTitle: 'Senior Sustainability Consultant',
      presenterCompany: 'GreenBuild Solutions',
      presenterImage: { uri: 'https://via.placeholder.com/80/0e4e96/FFFFFF?text=ED' },
      date: '2025-06-12',
      time: '14:00 - 15:30',
      timezone: 'BST (UTC+1)',
      duration: '90 minutes',
      registeredCount: 156,
      maxAttendees: 500,
      price: 'Free',
      category: 'Sustainability',
      level: 'Intermediate',
      language: 'English',
      platform: 'Zoom',
      description: 'Join us for an insightful webinar on the future of sustainable construction practices. Learn about emerging technologies, innovative materials, and regulatory changes that are shaping the future of environmentally responsible building design and construction.',
      objectives: [
        'Understand the latest sustainable building technologies',
        'Learn about net-zero energy building strategies',
        'Explore circular economy principles in construction',
        'Stay updated on regulatory changes and certifications',
        'Analyze real-world case studies of successful projects'
      ],
      topics: [
        'Latest advancements in sustainable building materials',
        'Net-zero energy building strategies',
        'Circular economy principles in construction',
        'Regulatory landscape and certification updates',
        'Case studies of award-winning sustainable projects',
        'Future trends in green construction technology'
      ],
      speakerBio: 'Emma Davis is a LEED Accredited Professional with over 15 years of experience in sustainable design and construction. She has consulted on numerous high-profile green building projects across Europe and North America, and is a frequent speaker at industry conferences.',
      speakerCredentials: [
        'LEED Accredited Professional',
        'BREEAM Assessor',
        'Certified Passive House Designer',
        'Member of UK Green Building Council'
      ],
      agenda: [
        { time: '14:00-14:10', topic: 'Welcome & Introduction' },
        { time: '14:10-14:30', topic: 'Current State of Sustainable Construction' },
        { time: '14:30-14:50', topic: 'Emerging Technologies & Materials' },
        { time: '14:50-15:10', topic: 'Case Studies & Best Practices' },
        { time: '15:10-15:25', topic: 'Q&A Session' },
        { time: '15:25-15:30', topic: 'Closing Remarks' }
      ],
      benefits: [
        'CPD Certificate (1.5 hours)',
        'Downloadable presentation slides',
        'Access to recording for 30 days',
        'Networking opportunities',
        'Resource library access'
      ],
      requirements: [
        'Stable internet connection',
        'Computer or mobile device',
        'Basic knowledge of construction industry',
        'Optional: Notebook for taking notes'
      ],
      image: { uri: 'https://via.placeholder.com/400x200/0e4e96/FFFFFF?text=Sustainable+Construction' },
      tags: ['Sustainability', 'Construction', 'Green Building', 'LEED', 'Technology'],
      organizer: 'GreenBuild Solutions',
      organizerWebsite: 'https://greenbuild.com',
      socialLinks: {
        linkedin: 'https://linkedin.com/company/greenbuild-solutions',
        twitter: 'https://twitter.com/greenbuildsol',
        website: 'https://greenbuild.com'
      }
    };
  },

  async registerForWebinar(webinarId, registrationData) {
    try {
      console.log('📝 Registering for webinar:', webinarId);
      
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      // Save registration data
      const savedRegistration = await PortfolioService.saveWebinarRegistration({
        webinarId,
        ...registrationData
      });
      
      console.log('✅ Webinar registration successful');
      return savedRegistration;
      
    } catch (error) {
      console.error('❌ Error registering for webinar:', error);
      throw error;
    }
  }
};

// JOBENG Logo component
const JobengLogo = () => (
  <View style={styles.logoContainer}>
    <MaterialCommunityIcons name="school" size={24} color="#ffffff" />
  </View>
);

export default function WebinarRegistrationScreen({ route, navigation }) {
  // ── Profile integration (auto-injected) ──
  const profileCtx = useProfile();
  // === Live API Data ===
  const [userId, setUserId] = React.useState('default');
  React.useEffect(() => {
    AsyncStorage.getItem('userToken').then(t => { if (t) setUserId(t.slice(0, 16)); }).catch(() => {});
  }, []);
  React.useEffect(() => {
    if (userId === 'default') return;
    const _ck = `professional_${_profUserId}_webinarregistrationscreen`;
    apiFetch('/api/data/jobs?sort=created_at&order=desc&limit=20').then(d => {
      if (d && !d.error) {
        const arr = Array.isArray(d) ? d : (d.data || d.results || []);
        AsyncStorage.setItem(_ck, JSON.stringify(arr)).catch(() => {});
      }
    }).catch(() => {});
  }, [userId]);

  // Route params
  const { webinarId, webinarData, source = '' } = route?.params || {};

  // Main states
  const [loading, setLoading] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [webinar, setWebinar] = useState(null);
  const [profile, setProfile] = useState(null);

  // Form states
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [company, setCompany] = useState('');
  const [jobTitle, setJobTitle] = useState('');
  const [phone, setPhone] = useState('');
  const [linkedin, setLinkedIn] = useState('');
  const [experience, setExperience] = useState('');
  const [interests, setInterests] = useState('');

  // Preference states
  const [receiveRecording, setReceiveRecording] = useState(true);
  const [receiveUpdates, setReceiveUpdates] = useState(true);
  const [receiveReminders, setReceiveReminders] = useState(true);
  const [shareNetworking, setShareNetworking] = useState(false);

  // UI states
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showAgendaModal, setShowAgendaModal] = useState(false);
  const [showSpeakerModal, setShowSpeakerModal] = useState(false);
  const [activeTab, setActiveTab] = useState('overview');

  // Animation values
  const fadeAnim = useRef(new Animated.Value(0)).current;
  const slideAnim = useRef(new Animated.Value(50)).current;
  const successAnim = useRef(new Animated.Value(0)).current;

  // Load data on component mount and focus
  useEffect(() => {
    initializeScreen();
  }, []);

  useFocusEffect(
    React.useCallback(() => {
      console.log('🔄 WebinarRegistration focused - refreshing data');
      loadWebinarData();
    }, [])
  );

  const initializeScreen = async () => {
    try {
      setLoading(true);
      
      await Promise.all([
        loadWebinarData(),
        loadProfileData()
      ]);
      
      startAnimations();
      
      if (source) {
        console.log(`🔗 Navigated from ${source} to WebinarRegistration`);
      }
      
    } catch (error) {
      console.error('❌ Error initializing webinar registration screen:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadWebinarData = async () => {
    try {
      console.log('🔄 Loading webinar data...');
      
      let webinarDetails;
      if (webinarData) {
        webinarDetails = webinarData;
      } else if (webinarId) {
        webinarDetails = await WebinarService.getWebinarDetails(webinarId);
      } else {
        webinarDetails = WebinarService.getEnhancedMockWebinar();
      }
      
      setWebinar(webinarDetails);
      console.log('✅ Webinar data loaded');
      
    } catch (error) {
      console.error('❌ Error loading webinar data:', error);
    }
  };

  const loadProfileData = async () => {
    try {
      console.log('🔄 Loading profile data for auto-fill...');
      
      const profileData = await PortfolioService.getProfile();
      if (profileData) {
        setProfile(profileData);
        
        // Auto-fill form with profile data
        if (profileData.personalInfo) {
          setFirstName(profileData.personalInfo.firstName || '');
          setLastName(profileData.personalInfo.lastName || '');
          setEmail(profileData.personalInfo.email || '');
          setPhone(profileData.personalInfo.phone || '');
          setLinkedIn(profileData.personalInfo.linkedin || '');
        }
        
        if (profileData.workHistory && profileData.workHistory.length > 0) {
          const currentJob = profileData.workHistory[0];
          setCompany(currentJob.company || '');
          setJobTitle(currentJob.position || '');
        }
        
        console.log('✅ Profile data loaded and form auto-filled');
      }
      
    } catch (error) {
      console.error('❌ Error loading profile data:', error);
    }
  };

  const startAnimations = () => {
    Animated.parallel([
      Animated.timing(fadeAnim, {
        toValue: 1,
        duration: 800,
        useNativeDriver: true,
      }),
      Animated.timing(slideAnim, {
        toValue: 0,
        duration: 800,
        useNativeDriver: true,
      }),
    ]).start();
  };

  const onRefresh = async () => {
    setRefreshing(true);
    try {
      await loadWebinarData();
    } catch (error) {
      console.error('❌ Error refreshing:', error);
    } finally {
      setRefreshing(false);
    }
  };

  // Form validation
  const validateForm = () => {
    if (!firstName.trim()) {
      Alert.alert('Missing Information', 'Please enter your first name');
      return false;
    }
    if (!lastName.trim()) {
      Alert.alert('Missing Information', 'Please enter your last name');
      return false;
    }
    if (!email.trim()) {
      Alert.alert('Missing Information', 'Please enter your email address');
      return false;
    }
    
    // Enhanced email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      Alert.alert('Invalid Email', 'Please enter a valid email address');
      return false;
    }
    
    return true;
  };

  // Handle registration submission
  const handleSubmit = async () => {
    if (!validateForm()) return;

    setIsSubmitting(true);

    try {
      const registrationData = {
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        email: email.trim(),
        company: company.trim(),
        jobTitle: jobTitle.trim(),
        phone: phone.trim(),
        linkedin: linkedin.trim(),
        experience: experience.trim(),
        interests: interests.trim(),
        preferences: {
          receiveRecording,
          receiveUpdates,
          receiveReminders,
          shareNetworking
        },
        webinarTitle: webinar?.title,
        webinarDate: webinar?.date,
        webinarTime: webinar?.time
      };

      await WebinarService.registerForWebinar(webinar?.id, registrationData);
      
      // Show success animation and modal
      setShowSuccessModal(true);
      Animated.timing(successAnim, {
        toValue: 1,
        duration: 600,
        useNativeDriver: true,
      }).start();

    } catch (error) {
      console.error('❌ Registration error:', error);
      Alert.alert(
        'Registration Failed',
        'Unable to complete registration. Please try again.',
        [{ text: 'OK' }]
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // External links
  const openCalendar = () => {
    Alert.alert(
      'Add to Calendar',
      'Choose your calendar app:',
      [
        { text: 'Google Calendar', onPress: () => openGoogleCalendar() },
        { text: 'Outlook', onPress: () => openOutlookCalendar() },
        { text: 'Apple Calendar', onPress: () => openAppleCalendar() },
        { text: 'Cancel', style: 'cancel' }
      ]
    );
  };

  const openGoogleCalendar = () => {
    const startDate = new Date(`${webinar.date}T${webinar.time.split(' - ')[0]}`);
    const endDate = new Date(`${webinar.date}T${webinar.time.split(' - ')[1]}`);
    
    const url = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(webinar.title)}&dates=${startDate.toISOString().replace(/[-:]/g, '').split('.')[0]}Z/${endDate.toISOString().replace(/[-:]/g, '').split('.')[0]}Z&details=${encodeURIComponent(webinar.description)}`;
    
    Linking.openURL(url).catch(err => {
      console.error('❌ Error opening Google Calendar:', err);
      Alert.alert('Error', 'Unable to open Google Calendar');
    });
  };

  const openOutlookCalendar = () => {
    Alert.alert('Calendar', 'Outlook calendar integration would be implemented here');
  };

  const openAppleCalendar = () => {
    Alert.alert('Calendar', 'Apple calendar integration would be implemented here');
  };

  const openWebsite = (url) => {
    if (url) {
      Linking.openURL(url).catch(err => {
        console.error('❌ Error opening website:', err);
        Alert.alert('Error', 'Unable to open website');
      });
    }
  };

  const openLinkedIn = (url) => {
    if (url) {
      Linking.openURL(url).catch(err => {
        console.error('❌ Error opening LinkedIn:', err);
        Alert.alert('Error', 'Unable to open LinkedIn profile');
      });
    }
  };

  // Format date for display
  const formatDate = (dateString) => {
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  };

  // Get registration progress
  const getRegistrationProgress = () => {
    const total = webinar?.maxAttendees || 500;
    const registered = webinar?.registeredCount || 0;
    return (registered / total) * 100;
  };

  // Render loading state
  if (loading || !webinar) {
    return (
      <SafeAreaView style={styles.safeArea}>
        <StatusBar barStyle="light-content" backgroundColor="#0e4e96" />
        
        <View style={styles.header}>
          <TouchableOpacity
            style={styles.backButton}
            onPress={() => navigation.goBack()}
          >
            <Ionicons name="arrow-back" size={24} color="#ffffff" />
          </TouchableOpacity>
          <Text style={styles.headerTitle}>Webinar Registration</Text>
          <JobengLogo />
        </View>

        <View style={styles.loadingContainer}>
          <ActivityIndicator size={36} color="#0e4e96" />
          <Text style={styles.loadingText}>Loading webinar details...</Text>
        </View>
      </SafeAreaView>
    );
  }

  return (
    <SafeAreaView style={styles.safeArea}>
      <StatusBar barStyle="light-content" backgroundColor="#0e4e96" />

      {/* Header */}
      <View style={styles.header}>
        <TouchableOpacity
          style={styles.backButton}
          onPress={() => navigation.goBack()}
        >
          <Ionicons name="arrow-back" size={24} color="#ffffff" />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Webinar Registration</Text>
        <JobengLogo />
      </View>

      {/* Source indicator */}
      {source && (
        <View style={styles.sourceIndicator}>
          <Ionicons name="information-circle-outline" size={16} color="#007AFF" />
          <Text style={styles.sourceText}>From {source}</Text>
        </View>
      )}

      <ScrollView
        style={styles.container}
        showsVerticalScrollIndicator={false}
        refreshControl={
          <RefreshControl
            refreshing={refreshing}
            onRefresh={onRefresh}
            colors={['#0e4e96']}
            tintColor="#0e4e96"
          />
        }
      >
        {/* Enhanced Webinar Info Card */}
        <Animated.View
          style={[
            styles.webinarCard,
            {
              opacity: fadeAnim,
              transform: [{ translateY: slideAnim }]
            }
          ]}
        >
          <Image
            source={webinar.image}
            style={styles.webinarImage}
            resizeMode="cover"
          />
          
          {/* Registration Progress Indicator */}
          <View style={styles.progressContainer}>
            <View style={styles.progressBar}>
              <View 
                style={[
                  styles.progressFill, 
                  { width: `${getRegistrationProgress()}%` }
                ]} 
              />
            </View>
            <Text style={styles.progressText}>
              {webinar.registeredCount}/{webinar.maxAttendees} registered
            </Text>
          </View>

          <View style={styles.webinarInfo}>
            <View style={styles.webinarHeader}>
              <View style={styles.webinarTitleContainer}>
                <Text style={styles.webinarTitle}>{webinar.title}</Text>
                <Text style={styles.webinarSubtitle}>{webinar.subtitle}</Text>
              </View>
              <View style={styles.webinarBadges}>
                <View style={styles.priceBadge}>
                  <Text style={styles.priceBadgeText}>{webinar.price}</Text>
                </View>
                <View style={styles.levelBadge}>
                  <Text style={styles.levelBadgeText}>{webinar.level}</Text>
                </View>
              </View>
            </View>

            <View style={styles.presenterContainer}>
              <Image source={webinar.presenterImage} style={styles.presenterAvatar} />
              <View style={styles.presenterInfo}>
                <Text style={styles.webinarPresenter}>{webinar.presenter}</Text>
                <Text style={styles.presenterTitle}>{webinar.presenterTitle}</Text>
                <Text style={styles.presenterCompany}>{webinar.presenterCompany}</Text>
              </View>
              <TouchableOpacity
                style={styles.speakerButton}
                onPress={() => setShowSpeakerModal(true)}
              >
                <MaterialIcons name="info-outline" size={20} color="#0e4e96" />
              </TouchableOpacity>
            </View>

            <View style={styles.webinarMetaContainer}>
              <View style={styles.webinarMeta}>
                <MaterialCommunityIcons name="calendar" size={18} color="#0e4e96" />
                <Text style={styles.webinarMetaText}>{formatDate(webinar.date)}</Text>
              </View>

              <View style={styles.webinarMeta}>
                <MaterialCommunityIcons name="clock-outline" size={18} color="#0e4e96" />
                <Text style={styles.webinarMetaText}>{webinar.time} {webinar.timezone}</Text>
              </View>

              <View style={styles.webinarMeta}>
                <MaterialCommunityIcons name="timelapse" size={18} color="#0e4e96" />
                <Text style={styles.webinarMetaText}>{webinar.duration}</Text>
              </View>

              <View style={styles.webinarMeta}>
                <MaterialCommunityIcons name="video" size={18} color="#0e4e96" />
                <Text style={styles.webinarMetaText}>{webinar.platform}</Text>
              </View>
            </View>

            {/* Quick Actions */}
            <View style={styles.quickActions}>
              <TouchableOpacity
                style={styles.quickActionButton}
                onPress={() => setShowAgendaModal(true)}
              >
                <MaterialIcons name="schedule" size={16} color="#0e4e96" />
                <Text style={styles.quickActionText}>Agenda</Text>
              </TouchableOpacity>
              
              <TouchableOpacity
                style={styles.quickActionButton}
                onPress={openCalendar}
              >
                <MaterialIcons name="event" size={16} color="#0e4e96" />
                <Text style={styles.quickActionText}>Add to Calendar</Text>
              </TouchableOpacity>
              
              <TouchableOpacity
                style={styles.quickActionButton}
                onPress={() => openWebsite(webinar.organizerWebsite)}
              >
                <MaterialIcons name="language" size={16} color="#0e4e96" />
                <Text style={styles.quickActionText}>Website</Text>
              </TouchableOpacity>
            </View>
          </View>
        </Animated.View>

        {/* Tab Navigation */}
        <View style={styles.tabContainer}>
          <TouchableOpacity
            style={[styles.tab, activeTab === 'overview' && styles.activeTab]}
            onPress={() => setActiveTab('overview')}
          >
            <Text style={[
              styles.tabText,
              activeTab === 'overview' && styles.activeTabText
            ]}>
              Overview
            </Text>
          </TouchableOpacity>
          
          <TouchableOpacity
            style={[styles.tab, activeTab === 'registration' && styles.activeTab]}
            onPress={() => setActiveTab('registration')}
          >
            <Text style={[
              styles.tabText,
              activeTab === 'registration' && styles.activeTabText
            ]}>
              Registration
            </Text>
          </TouchableOpacity>
        </View>

        {/* Tab Content */}
        {activeTab === 'overview' ? (
          <Animated.View
            style={[
              styles.tabContent,
              {
                opacity: fadeAnim,
                transform: [{ translateY: slideAnim }]
              }
            ]}
          >
            {/* Webinar Details */}
            <View style={styles.detailsContainer}>
              <Text style={styles.detailsTitle}>About This Webinar</Text>
              <Text style={styles.detailsDescription}>{webinar.description}</Text>

              <Text style={styles.detailsSubtitle}>Learning Objectives</Text>
              <View style={styles.objectivesList}>
                {webinar.objectives.map((objective, index) => (
                  <View key={`objective-${index}`} style={styles.objectiveItem}>
                    <MaterialCommunityIcons name="target" size={16} color="#0e4e96" />
                    <Text style={styles.objectiveText}>{objective}</Text>
                  </View>
                ))}
              </View>

              <Text style={styles.detailsSubtitle}>What You'll Learn</Text>
              <View style={styles.topicsList}>
                {webinar.topics.map((topic, index) => (
                  <View key={`topic-${index}`} style={styles.topicItem}>
                    <MaterialCommunityIcons name="check-circle" size={16} color="#16a34a" />
                    <Text style={styles.topicText}>{topic}</Text>
                  </View>
                ))}
              </View>

              <Text style={styles.detailsSubtitle}>What's Included</Text>
              <View style={styles.benefitsList}>
                {webinar.benefits.map((benefit, index) => (
                  <View key={`benefit-${index}`} style={styles.benefitItem}>
                    <MaterialCommunityIcons name="gift" size={16} color="#8B5CF6" />
                    <Text style={styles.benefitText}>{benefit}</Text>
                  </View>
                ))}
              </View>

              <Text style={styles.detailsSubtitle}>Requirements</Text>
              <View style={styles.requirementsList}>
                {webinar.requirements.map((requirement, index) => (
                  <View key={`requirement-${index}`} style={styles.requirementItem}>
                    <MaterialCommunityIcons name="information" size={16} color="#F59E0B" />
                    <Text style={styles.requirementText}>{requirement}</Text>
                  </View>
                ))}
              </View>

              {/* Tags */}
              <Text style={styles.detailsSubtitle}>Topics</Text>
              <View style={styles.tagsContainer}>
                {webinar.tags.map((tag, index) => (
                  <View key={`tag-${index}`} style={styles.tag}>
                    <Text style={styles.tagText}>{tag}</Text>
                  </View>
                ))}
              </View>
            </View>
          </Animated.View>
        ) : (
          <Animated.View
            style={[
              styles.tabContent,
              {
                opacity: fadeAnim,
                transform: [{ translateY: slideAnim }]
              }
            ]}
          >
            {/* Enhanced Registration Form */}
            <View style={styles.formContainer}>
              <View style={styles.formHeader}>
                <Text style={styles.formTitle}>Registration Details</Text>
                {profile && (
                  <View style={styles.autoFillIndicator}>
                    <MaterialIcons name="auto-fix-high" size={16} color="#10B981" />
                    <Text style={styles.autoFillText}>Auto-filled from profile</Text>
                  </View>
                )}
              </View>

              {/* Personal Information */}
              <Text style={styles.sectionTitle}>Personal Information</Text>
              
              <View style={styles.inputRow}>
                <View style={styles.inputHalf}>
                  <Text style={styles.inputLabel}>First Name *</Text>
                  <TextInput
                    style={styles.input}
                    value={firstName}
                    onChangeText={setFirstName}
                    placeholder="John"
                    placeholderTextColor="#94A3B8"
                  />
                </View>

                <View style={styles.inputHalf}>
                  <Text style={styles.inputLabel}>Last Name *</Text>
                  <TextInput
                    style={styles.input}
                    value={lastName}
                    onChangeText={setLastName}
                    placeholder="Smith"
                    placeholderTextColor="#94A3B8"
                  />
                </View>
              </View>

              <Text style={styles.inputLabel}>Email Address *</Text>
              <TextInput
                style={styles.input}
                value={email}
                onChangeText={setEmail}
                placeholder="john.smith@example.com"
                placeholderTextColor="#94A3B8"
                keyboardType="email-address"
                autoCapitalize="none"
              />

              <Text style={styles.inputLabel}>Phone Number</Text>
              <TextInput
                style={styles.input}
                value={phone}
                onChangeText={setPhone}
                placeholder="+44 20 1234 5678"
                placeholderTextColor="#94A3B8"
                keyboardType="phone-pad"
              />

              {/* Professional Information */}
              <Text style={styles.sectionTitle}>Professional Information</Text>

              <Text style={styles.inputLabel}>Company</Text>
              <TextInput
                style={styles.input}
                value={company}
                onChangeText={setCompany}
                placeholder="Your company name"
                placeholderTextColor="#94A3B8"
              />

              <Text style={styles.inputLabel}>Job Title</Text>
              <TextInput
                style={styles.input}
                value={jobTitle}
                onChangeText={setJobTitle}
                placeholder="Your job title"
                placeholderTextColor="#94A3B8"
              />

              <Text style={styles.inputLabel}>LinkedIn Profile</Text>
              <TextInput
                style={styles.input}
                value={linkedin}
                onChangeText={setLinkedIn}
                placeholder="https://linkedin.com/in/yourprofile"
                placeholderTextColor="#94A3B8"
                autoCapitalize="none"
              />

              <Text style={styles.inputLabel}>Years of Experience</Text>
              <TextInput
                style={styles.input}
                value={experience}
                onChangeText={setExperience}
                placeholder="e.g. 5-10 years"
                placeholderTextColor="#94A3B8"
              />

              <Text style={styles.inputLabel}>Areas of Interest</Text>
              <TextInput
                style={[styles.input, styles.textArea]}
                value={interests}
                onChangeText={setInterests}
                placeholder="What specific topics are you most interested in learning about?"
                placeholderTextColor="#94A3B8"
                multiline
                numberOfLines={3}
                textAlignVertical="top"
              />

              {/* Preferences */}
              <Text style={styles.sectionTitle}>Preferences</Text>
              
              <View style={styles.switchContainer}>
                <View style={styles.switchRow}>
                  <View style={styles.switchTextContainer}>
                    <Text style={styles.switchLabel}>Receive webinar recording</Text>
                    <Text style={styles.switchDescription}>
                      Get access to the recording after the live event
                    </Text>
                  </View>
                  <Switch
                    value={receiveRecording}
                    onValueChange={setReceiveRecording}
                    trackColor={{ false: '#e2e8f0', true: '#bfdbfe' }}
                    thumbColor={receiveRecording ? '#0e4e96' : '#f4f4f5'}
                  />
                </View>

                <View style={styles.switchRow}>
                  <View style={styles.switchTextContainer}>
                    <Text style={styles.switchLabel}>Receive event reminders</Text>
                    <Text style={styles.switchDescription}>
                      Get notified 24 hours and 1 hour before the event
                    </Text>
                  </View>
                  <Switch
                    value={receiveReminders}
                    onValueChange={setReceiveReminders}
                    trackColor={{ false: '#e2e8f0', true: '#bfdbfe' }}
                    thumbColor={receiveReminders ? '#0e4e96' : '#f4f4f5'}
                  />
                </View>

                <View style={styles.switchRow}>
                  <View style={styles.switchTextContainer}>
                    <Text style={styles.switchLabel}>Receive updates</Text>
                    <Text style={styles.switchDescription}>
                      Get notified about similar webinars and events
                    </Text>
                  </View>
                  <Switch
                    value={receiveUpdates}
                    onValueChange={setReceiveUpdates}
                    trackColor={{ false: '#e2e8f0', true: '#bfdbfe' }}
                    thumbColor={receiveUpdates ? '#0e4e96' : '#f4f4f5'}
                  />
                </View>

                <View style={styles.switchRow}>
                  <View style={styles.switchTextContainer}>
                    <Text style={styles.switchLabel}>Share for networking</Text>
                    <Text style={styles.switchDescription}>
                      Allow other attendees to see your professional information
                    </Text>
                  </View>
                  <Switch
                    value={shareNetworking}
                    onValueChange={setShareNetworking}
                    trackColor={{ false: '#e2e8f0', true: '#bfdbfe' }}
                    thumbColor={shareNetworking ? '#0e4e96' : '#f4f4f5'}
                  />
                </View>
              </View>

              <TouchableOpacity
                style={[
                  styles.registerButton,
                  isSubmitting && styles.registerButtonDisabled
                ]}
                onPress={handleSubmit}
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <View style={styles.submitButtonContent}>
                    <ActivityIndicator size={20} color="#ffffff" />
                    <Text style={styles.registerButtonText}>Registering...</Text>
                  </View>
                ) : (
                  <View style={styles.submitButtonContent}>
                    <MaterialIcons name="event-available" size={20} color="#ffffff" />
                    <Text style={styles.registerButtonText}>Register Now</Text>
                  </View>
                )}
              </TouchableOpacity>
            </View>
          </Animated.View>
        )}
      </ScrollView>

      {/* Success Modal */}
      <Modal
        visible={showSuccessModal}
        transparent={true}
        animationType="fade"
        onRequestClose={() => setShowSuccessModal(false)}
      >
        <View style={styles.modalContainer}>
          <Animated.View
            style={[
              styles.successModalContent,
              {
                opacity: successAnim,
                transform: [
                  {
                    scale: successAnim.interpolate({
                      inputRange: [0, 1],
                      outputRange: [0.8, 1],
                    }),
                  },
                ],
              }
            ]}
          >
            <View style={styles.successIcon}>
              <MaterialIcons name="check-circle" size={60} color="#10B981" />
            </View>
            
            <Text style={styles.successTitle}>Registration Successful!</Text>
            <Text style={styles.successMessage}>
              You have successfully registered for "{webinar?.title}". 
              A confirmation email has been sent to {email}.
            </Text>

            <View style={styles.successActions}>
              <TouchableOpacity
                style={styles.calendarButton}
                onPress={() => {
                  setShowSuccessModal(false);
                  openCalendar();
                }}
              >
                <MaterialIcons name="event" size={20} color="#0e4e96" />
                <Text style={styles.calendarButtonText}>Add to Calendar</Text>
              </TouchableOpacity>
              
              <TouchableOpacity
                style={styles.doneButton}
                onPress={() => {
                  setShowSuccessModal(false);
                  navigation.goBack();
                }}
              >
                <Text style={styles.doneButtonText}>Done</Text>
              </TouchableOpacity>
            </View>
          </Animated.View>
        </View>
      </Modal>

      {/* Agenda Modal */}
      <Modal
        visible={showAgendaModal}
        transparent={true}
        animationType="slide"
        onRequestClose={() => setShowAgendaModal(false)}
      >
        <View style={styles.modalContainer}>
          <View style={styles.agendaModalContent}>
            <View style={styles.modalHeader}>
              <Text style={styles.modalTitle}>Webinar Agenda</Text>
              <TouchableOpacity onPress={() => setShowAgendaModal(false)}>
                <Ionicons name="close" size={24} color="#64748B" />
              </TouchableOpacity>
            </View>

            <ScrollView style={styles.agendaContent}>
              {webinar?.agenda?.map((item, index) => (
                <View key={`agenda-${index}`} style={styles.agendaItem}>
                  <View style={styles.agendaTime}>
                    <Text style={styles.agendaTimeText}>{item.time}</Text>
                  </View>
                  <View style={styles.agendaTopic}>
                    <Text style={styles.agendaTopicText}>{item.topic}</Text>
                  </View>
                </View>
              ))}
            </ScrollView>
          </View>
        </View>
      </Modal>

      {/* Speaker Modal */}
      <Modal
        visible={showSpeakerModal}
        transparent={true}
        animationType="slide"
        onRequestClose={() => setShowSpeakerModal(false)}
      >
        <View style={styles.modalContainer}>
          <View style={styles.speakerModalContent}>
            <View style={styles.modalHeader}>
              <Text style={styles.modalTitle}>About the Speaker</Text>
              <TouchableOpacity onPress={() => setShowSpeakerModal(false)}>
                <Ionicons name="close" size={24} color="#64748B" />
              </TouchableOpacity>
            </View>

            <ScrollView style={styles.speakerContent}>
              <View style={styles.speakerHeader}>
                <Image source={webinar?.presenterImage} style={styles.speakerAvatar} />
                <View style={styles.speakerInfo}>
                  <Text style={styles.speakerName}>{webinar?.presenter}</Text>
                  <Text style={styles.speakerTitle}>{webinar?.presenterTitle}</Text>
                  <Text style={styles.speakerCompany}>{webinar?.presenterCompany}</Text>
                </View>
              </View>

              <Text style={styles.speakerBioTitle}>Biography</Text>
              <Text style={styles.speakerBio}>{webinar?.speakerBio}</Text>

              <Text style={styles.speakerCredentialsTitle}>Credentials</Text>
              <View style={styles.credentialsList}>
                {webinar?.speakerCredentials?.map((credential, index) => (
                  <View key={`credential-${index}`} style={styles.credentialItem}>
                    <MaterialIcons name="verified" size={16} color="#10B981" />
                    <Text style={styles.credentialText}>{credential}</Text>
                  </View>
                ))}
              </View>

              {/* Social Links */}
              <View style={styles.socialLinks}>
                <TouchableOpacity
                  style={styles.socialButton}
                  onPress={() => openLinkedIn(webinar?.socialLinks?.linkedin)}
                >
                  <FontAwesome5 name="linkedin" size={20} color="#0077B5" />
                  <Text style={styles.socialButtonText}>LinkedIn</Text>
                </TouchableOpacity>
                
                <TouchableOpacity
                  style={styles.socialButton}
                  onPress={() => openWebsite(webinar?.socialLinks?.website)}
                >
                  <MaterialIcons name="language" size={20} color="#0e4e96" />
                  <Text style={styles.socialButtonText}>Website</Text>
                </TouchableOpacity>
              </View>
            </ScrollView>
          </View>
        </View>
      </Modal>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: '#F8FAFC',
  },
  header: {
    backgroundColor: '#0e4e96',
    paddingVertical: 15,
    paddingHorizontal: 20,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  backButton: {
    padding: 4,
  },
  headerTitle: {
    color: '#ffffff',
    fontSize: 18,
    fontWeight: '600',
    flex: 1,
    textAlign: 'center',
    marginHorizontal: 16,
  },
  logoContainer: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  loadingText: {
    marginTop: 16,
    fontSize: 16,
    color: '#64748B',
    textAlign: 'center',
  },
  sourceIndicator: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#f0f8ff',
    paddingHorizontal: 12,
    paddingVertical: 8,
    marginHorizontal: 16,
    marginTop: 8,
    borderRadius: 8,
    gap: 8,
  },
  sourceText: {
    fontSize: 14,
    color: '#007AFF',
    fontWeight: '500',
  },
  container: {
    flex: 1,
  },
  webinarCard: {
    backgroundColor: '#ffffff',
    margin: 16,
    borderRadius: 16,
    overflow: 'hidden',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4,
  },
  webinarImage: {
    width: '100%',
    height: 160,
  },
  progressContainer: {
    paddingHorizontal: 16,
    paddingTop: 12,
  },
  progressBar: {
    height: 4,
    backgroundColor: '#E2E8F0',
    borderRadius: 2,
    overflow: 'hidden',
  },
  progressFill: {
    height: '100%',
    backgroundColor: '#10B981',
    borderRadius: 2,
  },
  progressText: {
    fontSize: 12,
    color: '#64748B',
    marginTop: 4,
    textAlign: 'center',
  },
  webinarInfo: {
    padding: 16,
  },
  webinarHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 16,
  },
  webinarTitleContainer: {
    flex: 1,
    marginRight: 12,
  },
  webinarTitle: {
    fontSize: 20,
    fontWeight: '700',
    color: '#1E293B',
    marginBottom: 4,
    lineHeight: 24,
  },
  webinarSubtitle: {
    fontSize: 14,
    color: '#64748B',
    lineHeight: 18,
  },
  webinarBadges: {
    gap: 4,
  },
  priceBadge: {
    backgroundColor: '#10B981',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    alignItems: 'center',
  },
  priceBadgeText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#ffffff',
  },
  levelBadge: {
    backgroundColor: '#F59E0B',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    alignItems: 'center',
  },
  levelBadgeText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#ffffff',
  },
  presenterContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
    padding: 12,
    backgroundColor: '#F8FAFC',
    borderRadius: 12,
  },
  presenterAvatar: {
    width: 48,
    height: 48,
    borderRadius: 24,
    marginRight: 12,
  },
  presenterInfo: {
    flex: 1,
  },
  webinarPresenter: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1E293B',
    marginBottom: 2,
  },
  presenterTitle: {
    fontSize: 13,
    color: '#64748B',
    marginBottom: 1,
  },
  presenterCompany: {
    fontSize: 12,
    color: '#94A3B8',
  },
  speakerButton: {
    padding: 8,
    borderRadius: 8,
    backgroundColor: '#ffffff',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
    elevation: 1,
  },
  webinarMetaContainer: {
    gap: 8,
    marginBottom: 16,
  },
  webinarMeta: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  webinarMetaText: {
    fontSize: 14,
    color: '#334155',
    fontWeight: '500',
  },
  quickActions: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 8,
  },
  quickActionButton: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 8,
    paddingHorizontal: 12,
    backgroundColor: '#F1F5F9',
    borderRadius: 8,
    gap: 4,
  },
  quickActionText: {
    fontSize: 12,
    fontWeight: '500',
    color: '#0e4e96',
  },
  tabContainer: {
    flexDirection: 'row',
    paddingHorizontal: 16,
    marginBottom: 8,
    gap: 8,
  },
  tab: {
    flex: 1,
    paddingVertical: 12,
    paddingHorizontal: 16,
    backgroundColor: '#ffffff',
    borderRadius: 12,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 1,
  },
  activeTab: {
    backgroundColor: '#0e4e96',
  },
  tabText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#64748B',
  },
  activeTabText: {
    color: '#ffffff',
  },
  tabContent: {
    flex: 1,
  },
  formContainer: {
    backgroundColor: '#ffffff',
    margin: 16,
    padding: 20,
    borderRadius: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4,
  },
  formHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20,
  },
  formTitle: {
    fontSize: 20,
    fontWeight: '700',
    color: '#1E293B',
  },
  autoFillIndicator: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  autoFillText: {
    fontSize: 12,
    color: '#10B981',
    fontWeight: '500',
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1E293B',
    marginTop: 16,
    marginBottom: 12,
  },
  inputRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 12,
  },
  inputHalf: {
    flex: 1,
  },
  inputLabel: {
    fontSize: 14,
    color: '#374151',
    marginBottom: 6,
    fontWeight: '500',
  },
  input: {
    backgroundColor: '#F8FAFC',
    borderWidth: 1,
    borderColor: '#E2E8F0',
    borderRadius: 8,
    paddingHorizontal: 14,
    paddingVertical: 12,
    fontSize: 14,
    color: '#1E293B',
    marginBottom: 16,
  },
  textArea: {
    height: 80,
    textAlignVertical: 'top',
  },
  switchContainer: {
    marginVertical: 8,
  },
  switchRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 16,
    paddingVertical: 8,
  },
  switchTextContainer: {
    flex: 1,
    marginRight: 16,
  },
  switchLabel: {
    fontSize: 14,
    color: '#374151',
    fontWeight: '500',
    marginBottom: 2,
  },
  switchDescription: {
    fontSize: 12,
    color: '#64748B',
    lineHeight: 16,
  },
  registerButton: {
    backgroundColor: '#0e4e96',
    paddingVertical: 16,
    borderRadius: 12,
    alignItems: 'center',
    marginTop: 16,
    shadowColor: '#0e4e96',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 4,
  },
  registerButtonDisabled: {
    backgroundColor: '#94A3B8',
    shadowOpacity: 0.1,
  },
  submitButtonContent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  registerButtonText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#ffffff',
  },
  detailsContainer: {
    backgroundColor: '#ffffff',
    margin: 16,
    padding: 20,
    borderRadius: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4,
    marginBottom: 32,
  },
  detailsTitle: {
    fontSize: 20,
    fontWeight: '700',
    color: '#1E293B',
    marginBottom: 12,
  },
  detailsSubtitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1E293B',
    marginTop: 20,
    marginBottom: 12,
  },
  detailsDescription: {
    fontSize: 14,
    color: '#374151',
    lineHeight: 22,
    marginBottom: 16,
  },
  objectivesList: {
    marginBottom: 16,
  },
  objectiveItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 8,
    gap: 8,
  },
  objectiveText: {
    fontSize: 14,
    color: '#374151',
    flex: 1,
    lineHeight: 20,
  },
  topicsList: {
    marginBottom: 16,
  },
  topicItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 8,
    gap: 8,
  },
  topicText: {
    fontSize: 14,
    color: '#374151',
    flex: 1,
    lineHeight: 20,
  },
  benefitsList: {
    marginBottom: 16,
  },
  benefitItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 8,
    gap: 8,
  },
  benefitText: {
    fontSize: 14,
    color: '#374151',
    flex: 1,
    lineHeight: 20,
  },
  requirementsList: {
    marginBottom: 16,
  },
  requirementItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 8,
    gap: 8,
  },
  requirementText: {
    fontSize: 14,
    color: '#374151',
    flex: 1,
    lineHeight: 20,
  },
  tagsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  tag: {
    backgroundColor: '#E2E8F0',
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 16,
  },
  tagText: {
    fontSize: 12,
    color: '#64748B',
    fontWeight: '500',
  },
  modalContainer: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  successModalContent: {
    backgroundColor: '#ffffff',
    borderRadius: 20,
    padding: 24,
    alignItems: 'center',
    maxWidth: 320,
    width: '100%',
  },
  successIcon: {
    marginBottom: 16,
  },
  successTitle: {
    fontSize: 20,
    fontWeight: '700',
    color: '#1E293B',
    marginBottom: 8,
    textAlign: 'center',
  },
  successMessage: {
    fontSize: 14,
    color: '#64748B',
    textAlign: 'center',
    lineHeight: 20,
    marginBottom: 24,
  },
  successActions: {
    flexDirection: 'row',
    gap: 12,
    width: '100%',
  },
  calendarButton: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 12,
    paddingHorizontal: 16,
    backgroundColor: '#F1F5F9',
    borderRadius: 8,
    gap: 6,
  },
  calendarButtonText: {
    fontSize: 14,
    fontWeight: '500',
    color: '#0e4e96',
  },
  doneButton: {
    flex: 1,
    paddingVertical: 12,
    paddingHorizontal: 16,
    backgroundColor: '#0e4e96',
    borderRadius: 8,
    alignItems: 'center',
  },
  doneButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#ffffff',
  },
  agendaModalContent: {
    backgroundColor: '#ffffff',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    maxHeight: '70%',
    width: '100%',
    position: 'absolute',
    bottom: 0,
  },
  speakerModalContent: {
    backgroundColor: '#ffffff',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    maxHeight: '80%',
    width: '100%',
    position: 'absolute',
    bottom: 0,
  },
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#F1F5F9',
  },
  modalTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#1E293B',
  },
  agendaContent: {
    padding: 20,
  },
  agendaItem: {
    flexDirection: 'row',
    marginBottom: 16,
    gap: 12,
  },
  agendaTime: {
    width: 80,
  },
  agendaTimeText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#0e4e96',
  },
  agendaTopic: {
    flex: 1,
  },
  agendaTopicText: {
    fontSize: 14,
    color: '#374151',
    lineHeight: 18,
  },
  speakerContent: {
    padding: 20,
  },
  speakerHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 20,
  },
  speakerAvatar: {
    width: 80,
    height: 80,
    borderRadius: 40,
    marginRight: 16,
  },
  speakerInfo: {
    flex: 1,
  },
  speakerName: {
    fontSize: 18,
    fontWeight: '600',
    color: '#1E293B',
    marginBottom: 4,
  },
  speakerTitle: {
    fontSize: 14,
    color: '#64748B',
    marginBottom: 2,
  },
  speakerCompany: {
    fontSize: 13,
    color: '#94A3B8',
  },
  speakerBioTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1E293B',
    marginBottom: 8,
  },
  speakerBio: {
    fontSize: 14,
    color: '#374151',
    lineHeight: 20,
    marginBottom: 20,
  },
  speakerCredentialsTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1E293B',
    marginBottom: 12,
  },
  credentialsList: {
    marginBottom: 20,
  },
  credentialItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
    gap: 8,
  },
  credentialText: {
    fontSize: 14,
    color: '#374151',
  },
  socialLinks: {
    flexDirection: 'row',
    gap: 12,
  },
  socialButton: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 12,
    paddingHorizontal: 16,
    backgroundColor: '#F8FAFC',
    borderRadius: 8,
    gap: 8,
  },
  socialButtonText: {
    fontSize: 14,
    fontWeight: '500',
    color: '#374151',
  },
});
